import React from 'react';
import { Plus } from 'lucide-react';
import { MenuItem } from '../../lib/types';
import { formatCurrency } from '../../lib/utils';
import { useLanguage } from '../../lib/i18n';
interface MenuItemCardProps {
  item: MenuItem;
  onClick: (item: MenuItem) => void;
  primaryColor?: string;
  displayName?: string;
  displayDescription?: string | null;
  theme?: 'default' | 'capricho' | 'natucafe';
}
export function MenuItemCard({
  item,
  onClick,
  primaryColor,
  displayName,
  displayDescription,
  theme = 'default'
}: MenuItemCardProps) {
  const {
    t
  } = useLanguage();
  const itemName = displayName || item.name;
  const itemDesc = displayDescription !== undefined ? displayDescription : item.description;
  const isCapricho = theme === 'capricho';
  const isNatuCafe = theme === 'natucafe';
  return <button onClick={() => onClick(item)} className={isNatuCafe ? 'w-full bg-[#1A1614] rounded-2xl overflow-hidden border border-[#2A2420] hover:border-[#C6A969]/30 transition-all hover:shadow-xl hover:shadow-[#C6A969]/10 group text-left flex flex-col h-full' : isCapricho ? 'w-full bg-white rounded-2xl overflow-hidden border border-[#E8DDD0] hover:border-[#8B5E3C]/30 transition-all hover:shadow-xl hover:shadow-[#8B5E3C]/5 group text-left flex flex-col h-full' : 'w-full bg-[#141414] rounded-2xl overflow-hidden border border-white/5 hover:border-[#C9A34E]/30 transition-all hover:shadow-xl hover:shadow-[#C9A34E]/5 group text-left flex flex-col h-full'} data-id="element-1227">
      {item.image_url && <div className={`relative w-full h-32 sm:h-48 ${isNatuCafe ? 'bg-[#0F0D0B]' : isCapricho ? 'bg-[#F5EDE3]' : 'bg-[#0B0B0B]'} overflow-hidden shrink-0`} data-id="element-1228">
          <img src={item.image_url} alt={itemName} className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-300" data-id="element-1229" />
          <div className={`absolute inset-0 bg-gradient-to-t ${isNatuCafe ? 'from-[#1A1614]' : isCapricho ? 'from-white' : 'from-[#0B0B0B]'} via-transparent to-transparent opacity-60`} data-id="element-1230" />
        </div>}

      <div className="p-3 sm:p-5 flex flex-col flex-1" data-id="element-1231">
        <h3 className={isNatuCafe ? 'text-base sm:text-xl font-black text-[#F5F0EB] leading-tight group-hover:text-[#C6A969] transition-colors mb-1 sm:mb-1.5' : isCapricho ? 'text-base sm:text-xl font-black text-[#3D2B1F] leading-tight group-hover:text-[#8B5E3C] transition-colors mb-1 sm:mb-1.5' : 'text-base sm:text-xl font-black text-white leading-tight group-hover:text-[#C9A34E] transition-colors mb-1 sm:mb-1.5'} style={{
        fontFamily: "'Playfair Display', serif"
      }} data-id="element-1232">
          {itemName}
        </h3>
        <span className={isNatuCafe ? 'text-sm sm:text-lg font-bold text-[#C6A969] mb-1.5 sm:mb-2' : isCapricho ? 'text-sm sm:text-lg font-bold text-[#8B5E3C] mb-1.5 sm:mb-2' : 'text-sm sm:text-lg font-bold text-[#C9A34E] mb-1.5 sm:mb-2'} data-id="element-1233">
          {formatCurrency(Number(item.price) || 0)}
        </span>

        {itemDesc && <p className={`text-xs sm:text-sm ${isNatuCafe ? 'text-[#8B7B6B]' : isCapricho ? 'text-[#8B7355]/70' : 'text-white/60'} mb-3 sm:mb-4 line-clamp-2 leading-relaxed flex-1`} data-id="element-1234">
            {itemDesc}
          </p>}

        <div className="flex items-center justify-between mt-auto pt-1" data-id="element-1235">
          <div className="flex-1" data-id="element-1236" />
          <div className={isNatuCafe ? 'flex items-center gap-1 sm:gap-2 text-[13px] sm:text-sm font-bold text-[#C6A969] group-hover:text-[#D4883A] transition-colors' : isCapricho ? 'flex items-center gap-1 sm:gap-2 text-[13px] sm:text-sm font-bold text-[#8B5E3C] group-hover:text-[#3D2B1F] transition-colors' : 'flex items-center gap-1 sm:gap-2 text-[13px] sm:text-sm font-bold text-[#C9A34E] group-hover:text-white transition-colors'} data-id="element-1237">
            <Plus className="w-4 h-4 sm:w-5 sm:h-5" data-id="element-1238" />
            <span data-id="element-1239">{t('add_to_cart')}</span>
          </div>
        </div>
      </div>
    </button>;
}